export default "__VITE_ASSET__VCB16faB__"